import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import ET3Div from "../../../et3-div";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";
import PopUpCloseButton from "../../../et3-shared-components/action-buttons/popUpCloseButton";

const EditClosePopUpIcon = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={540}
      height={50}
      fDirection="column"
      alignItems="flex-end"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <PopUpCloseButton
        onClick={() => getCorePopUpStore().editPopUpVisibleType.set("")}
      />
    </ET3Div>
  );
});

export default EditClosePopUpIcon;
